import { throttle } from "./Util";

const $scrollBox = $(".js-scroll-box");
const $gangItem = $(".js-gang-item");
const $animatedTextCarousel = $(".js-animated-text-carousel");
let timer;

App.W.on("resize", throttle(setScrollBox, 200));

/* если элемент со скроллящимся текстом попал в вьюпорт (20%  от низа экрана), то активируем его анимацию */
// App.W.on(
//     "scroll.animatetext",
//     throttle(function () {
//         if (
//             App.W.scrollTop() >
//             $animatedTextCarousel.offset().top - App.W.outerHeight() / 1.2
//         ) {
//             animatedTextRun();
//             App.W.off("scroll.animatetext");
//         }
//     }, 200)
// );

export function scrollWords() {
    setTimeout(function () {
        animatedTextRun();
    }, 500);
}

scrollWords();
/* Раскрытие информации в блоке our gang */
$gangItem.on("click", function (e) {
    const $currItem = $(this);
    const $currDescription = $currItem.find(".js-gang-item-description");
    const $openedItem = $gangItem.filter("._open");

    // если клик по текущей
    if ($currItem.is("._open")) {
        $currItem.removeClass("_opened");

        $currDescription.find(".js-gang-tooltip").fadeOut(300, function () {
            $currDescription.stop().slideUp(function () {
                $currItem.removeClass("_open");
            });
        });
    } else {
        if ($openedItem.length) {
            $openedItem.find(".js-gang-tooltip").fadeOut(300, function () {
                $openedItem.find(".js-gang-item-description").slideUp();
                $openedItem.removeClass("_open _opened");

                $currItem.addClass("_opened");
                $currDescription.slideDown(function () {
                    $currItem.addClass("_open");
                    $currDescription.find(".js-gang-tooltip").fadeIn(300);
                });
            });
        } else {
            $currItem.addClass("_opened");
            $currDescription.slideDown(function () {
                $currItem.addClass("_open");
                $currDescription.find(".js-gang-tooltip").fadeIn(300);
            });
        }
    }

    e.preventDefault();
});

// $("body").niceScroll();
// $("wrap").niceScroll();

/* Устанавливаем со скроллом элемент или нет (блок projects & cases) */
function setScrollBox() {
    
    $(".projects-item").removeClass("_with-scroll");

    $scrollBox.each(function () {
        const $currScrollBox = $(this);
        const $scrollBoxContent = $currScrollBox.find(".js-scroll-box-content");

        if ($scrollBoxContent.outerHeight() > $currScrollBox.outerHeight()) {
            $currScrollBox.closest(".projects-item").addClass("_with-scroll");
        } else {
            $currScrollBox
                .closest(".projects-item")
                .addClass("_without-scroll");
        }
    });
}

/* Анимация текста — смена текста "по строкам" */
function animatedTextRun() {
    const lang = $("html")[0].lang;
    const $animatedList = $animatedTextCarousel.find('.js-animated-text-carousel-list');
    const $animatedStr = $animatedList.find(" > div").eq(0);
    const animatedStrCount = $animatedList.find(" > div").length;
    let currIndex = 0;
    clearInterval(timer);
    

    // if (lang == "ru") {
    //     $animatedTextCarousel.find("[lang='en']").removeAttr("style");

    // }

    // if (lang === "en") {
    //     $animatedTextCarousel.find("[lang='ru']").removeAttr("style");
    // }

    timer = setInterval(function () {
        const strHeight = $animatedStr.outerHeight();

        currIndex++;

        if (currIndex === 1) {
            $animatedTextCarousel.removeClass("_timeout");
        }

        $animatedList.css({
            transform: `translateY(-${currIndex * strHeight}px)`,
        });

        


        if (currIndex === animatedStrCount - 1) {
            setTimeout(function () {
                $animatedList.removeAttr("style");
                $animatedTextCarousel.addClass("_timeout");
                currIndex = 0;
            }, 500);
        }
    }, 1500);
}



// WEBPACK FOOTER //
// ./_src/js/MainPage.js